import { type JSX, type ReactNode } from 'react';

/**
 * @public
 */
export interface ErrorStateSlotProps {
  children: ReactNode | ((errorMessage: string) => JSX.Element);
}

/**
 * @public
 */
export const ErrorStateSlot = ({ children }: ErrorStateSlotProps) => (
  <>{children}</>
);
